// extracted by mini-css-extract-plugin
export var contrastLow = "_4a-1";
export var externalLink = "_4a-2";
export var externalLinkIcon = "_4a-3";
export var link = "_4a-0";
export var linkLabel = "_4a-4";